// Common error extraction helper for API errors
export function extractError(e, fallback = 'Failed') {
  try {
    const d = e?.response?.data;
    if (!d) return fallback;
    if (typeof d === 'string') return d;
    if (typeof d.detail === 'string') return d.detail;
    if (Array.isArray(d.detail) && d.detail.length > 0) {
      // Pydantic validation errors
      return d.detail.map(x => x.msg || JSON.stringify(x)).join('; ');
    }
    if (d.detail) return JSON.stringify(d.detail);
    return fallback;
  } catch { return fallback; }
}
